export const SELECT_DATASET = 'SELECT_DATASET'
export const SELECT_LABEL = 'SELECT_LABEL'
export const LOAD_METADATA = 'LOAD_METADATA'
export const LOAD_DATA = 'LOAD_DATA'
